import { SVGProps } from "react";

function SvgComponent(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      {...props}
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
    >
      <g transform="translate(3.000000, 2.000000)">
        <mask id="user-mask" fill="white">
          <path d="M13.375,11.25 C15.7222102,11.25 17.625,13.1527898 17.625,15.5 L17.625,18 C17.625,18.9664983 16.8414983,19.75 15.875,19.75 L2.125,19.75 C1.15850169,19.75 0.375,18.9664983 0.375,18 L0.375,15.5 C0.375,13.1527898 2.27778981,11.25 4.625,11.25 L13.375,11.25 Z M13.375,12.75 L4.625,12.75 C3.10621694,12.75 1.875,13.9812169 1.875,15.5 L1.875,18 C1.875,18.1380712 1.98692881,18.25 2.125,18.25 L15.875,18.25 C16.0130712,18.25 16.125,18.1380712 16.125,18 L16.125,15.5 C16.125,13.9812169 14.8937831,12.75 13.375,12.75 Z M9,0.25 C11.5915016,0.25 13.6875,2.37926822 13.6875,5 C13.6875,7.62073178 11.5915016,9.75 9,9.75 C6.40849841,9.75 4.3125,7.62073178 4.3125,5 C4.3125,2.37926822 6.40849841,0.25 9,0.25 Z M9,1.75 C7.24225919,1.75 5.8125,3.20245378 5.8125,5 C5.8125,6.79754622 7.24225919,8.25 9,8.25 C10.7577408,8.25 12.1875,6.79754622 12.1875,5 C12.1875,3.20245378 10.7577408,1.75 9,1.75 Z" />
        </mask>
        <g transform="translate(-3.000000, -2.000000)" mask="url(#user-mask)">
          <rect fill="currentColor" x="0" y="0" width="24" height="24" />
        </g>
      </g>
    </svg>
  );
}

export default SvgComponent;
